import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconListBullets: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconListBullets"><Path d="M8.75 6L20.25 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Circle cx="4.2" cy="5.9998" r="1.2" fill="currentColor"/><Path d="M8.75 12L20.25 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Circle cx="4.2" cy="11.9998" r="1.2" fill="currentColor"/><Path d="M8.75 18L20.25 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Circle cx="4.2" cy="17.9998" r="1.2" fill="currentColor"/></CentralIconBase>;
});

export default IconListBullets;
